import { createSelector } from 'reselect';
import { get } from 'lodash';

export const userInfoSelector = state => get( state, 'auth.userInfo', {} );

export const userNameAndLocationSelector = createSelector( userInfoSelector, ( userInfo ) => {
    const fullname = userInfo.firstname && userInfo.lastname ? `${userInfo.firstname} ${userInfo.lastname}` : '';
    const displayRealmName = userInfo.fullRealmName || userInfo.realmName || '';
    return { displayRealmName, fullname };
} );

export const hasGlobalAccessSelector = createSelector( userInfoSelector, ( userInfo ) => {
    const permissions = get( userInfo, 'permissions', [] );

    return permissions.includes( 'EFD.GlobalAccess' );
} );

export const hasNewFeatureVisibilitySelector = createSelector( userInfoSelector, ( userInfo ) => {
    const permissions = get( userInfo, 'permissions', [] );

    return permissions.includes( 'EFD.NewFeatureVisibility' );
} );
